// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import store from "./store";
import router from "./router/index";
import "./router/permission"

// 监听器为被动（passive）监听器。 Chrome主要利用该特性来优化页面的滑动性能
import 'default-passive-events'


import axios from 'axios';
try {
  let adminNo = JSON.parse(window.localStorage.getItem('admin')).adminNo;
axios.defaults.headers.common["Username"] = adminNo
} catch (error) {
}
import 'element-ui/lib/theme-chalk/index.css';
//阿里图标库
import'@/assets/iconfonts/font_4343650_efqb4n67gfq/iconfont.css'

// 引入图标
import '@/assets/iconfonts/fonts/iconfont.css';



// 引入echarts
import echarts from 'echarts'

// import router from 'guci-router';
import { install } from '@icon-park/vue/es/all';
import '@icon-park/vue/styles/index.css';
install(Vue)

import html2canvas from 'html2canvas';
Vue.prototype.$html2canvas = html2canvas;


import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import Quill from 'quill'

const BlockEmbed = Quill.import('formats/video')
const Images = Quill.import('formats/image')
const Inline = Quill.import('blots/inline');

class ImageBlot extends Images {
  static create(value) {
    const node = super.create(value)
    node.setAttribute('src', value)
    node.setAttribute('style', 'max-width: 50%; height: auto; border-radius: 8px;')
    return node
  }
  static value(node) {
    return node.getAttribute('src')
  }
}

class VideoBlot extends BlockEmbed {
  static create(value) {
    const node = super.create()
    node.setAttribute('src', value)
    node.setAttribute('controls', '') 
    node.setAttribute('style', 'max-width: 50%; height: auto; border-radius: 8px;')
    return node
  }
  static value(node) {
    return node.getAttribute('src')
  }
}

VideoBlot.blotName = 'video'
VideoBlot.tagName = 'video'
ImageBlot.blotName = 'image'
ImageBlot.tagName = 'img'
Quill.register('formats/video', VideoBlot)
Quill.register('formats/image', ImageBlot)


class AudioBlot extends Inline {
  static create(value) {
    const node = super.create();
    node.setAttribute('src', value);
    node.setAttribute('controls', 'controls');
    node.setAttribute('type', 'audio/mpeg');
    node.setAttribute('style', 'vertical-align: middle; margin: 8px 0;');
    return node;
  }
  static value(node) {
    return node.getAttribute('src');
  }
}

AudioBlot.blotName = 'audio';
AudioBlot.tagName = 'audio';
Quill.register('formats/audio', AudioBlot)





import VueTour from 'vue-tour'
import  'vue-tour/dist/vue-tour.css'
Vue.use(VueTour)


import pdf from 'vue-pdf'
Vue.component('GuciYa-vue', pdf)

import VueOfficeDocx from '@vue-office/docx'
Vue.component('GuciYa-VueOfficeDocx', VueOfficeDocx)


import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})


import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);


import MultiFunctionalUploadView from '@/MultiFunctionalUploadView/MultiFunctionalUploadView.vue';
Vue.component('Vue-MultiFunctionalUploadView', MultiFunctionalUploadView)

import GuciTable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(GuciTable)
import './utils/GuciTable'

import { GuciLan } from './utils/GuciI18n'

import './utils/console'


// 引入全局样式
import './assets/css/global.css';
import { Button, Select, Form, Radio,Tabs,TabPane,RadioGroup,RadioButton, Table, Container, Message, Pagination, Dialog, Autocomplete,
  Submenu, Menu, MenuItem, MenuItemGroup, Input, Option, FormItem, TableColumn, Row,
  Icon, Dropdown, DropdownMenu, DropdownItem, Header, Aside, Main, Footer, Popover, Upload,
  MessageBox,Slider, Col,DatePicker,TimeSelect, Cascader,Image,Link,Card,Tree,CheckboxGroup,Checkbox,ButtonGroup,Divider,TimePicker,InputNumber,Descriptions,DescriptionsItem,
  Breadcrumb,BreadcrumbItem,Notification,Tag,Empty,Tooltip,Collapse,CollapseItem,Steps,Step,Popconfirm,Drawer,Switch,Progress,Timeline,TimelineItem,Calendar,
} from 'element-ui';

Vue.use(Breadcrumb).use(BreadcrumbItem).use(Tag).use(Empty)
.use(Tooltip).use(Collapse).use(CollapseItem).use(Steps).use(Step)
.use(Popconfirm).use(Drawer).use(Switch).use(Progress)
.use(Timeline).use(TimelineItem).use(Calendar);

Vue.component('vue-components', quillEditor)

//引入加载样式
import { Loading } from 'element-ui';
Vue.use(Loading.directive);

import Chat from 'vue-beautiful-chat'
Vue.use(Chat)

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$message = Message;
Vue.prototype.$echarts = echarts
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$EventBus = new Vue()

Vue.prototype.$notify  = Notification;

Vue.prototype.$msgbox = MessageBox
// Vue.use(ElementUI);
Vue.use(Button);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(Col);
Vue.use(Slider)
Vue.use(Cascader);
Vue.use(Popover);
Vue.use(Footer);
Vue.use(Main);
Vue.use(Upload);
Vue.use(Aside);
Vue.use(Header);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Dropdown);
Vue.use(Icon);
Vue.use(Row);
Vue.use(TableColumn);
Vue.use(FormItem);
Vue.use(Option);
Vue.use(Select);
Vue.use(Form);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Container);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Submenu);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(Image);
Vue.use(Link);
Vue.use(Card);
Vue.use(Tree);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(ButtonGroup);
Vue.use(Divider);
Vue.use(TimePicker);
Vue.use(InputNumber);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Button);
// 时间选中
import timeSelect from '@/components/timeSelect/index.vue'
Vue.component('mz-time-select', timeSelect)


// import ElementUI from 'element-ui';
// import  customZh from './utils/customLocale'
// Vue.use(ElementUI, { locale: customZh });


import beautifulChat from './manager/afterSales/beautifulChat.vue'
Vue.component('model-Components', beautifulChat)

import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI)

import pinia from './pinia/pinia'
Vue.use(pinia)

// import sandiUI from "sandi-ui"
// Vue.use(sandiUI)



new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  GuciLan,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js